import { useEffect } from "react";

export default function RedirectPlayStore() {
  useEffect(() => {
    window.location.href =
      "https://play.google.com/store/apps/details?id=com.darkcainds.chefskills";
  }, []);

  return null;
}
